export default __webpack_public_path__ + "static/media/update.74ad9baf.jpg";